import api from "@/services/http/api";
import apiAuth from "@/services/http/apiAuth";

/* ============================================================
   PÚBLICAS
   ============================================================ */

export async function listarReferentes() {
  const res = await api.get("/referentes");
  return res.data;
}

export async function obtenerReferente(id) {
  const res = await api.get(`/referentes/${id}`);
  return res.data;
}

/* ============================================================
   ADMIN
   ============================================================ */

export async function listarReferentesAdmin() {
  const res = await apiAuth.get("/referentes/admin/all");
  return res.data;
}

export async function crearReferente(payload) {
  const res = await apiAuth.post("/referentes", payload);
  return res.data;
}

export async function editarReferente(id, payload) {
  const res = await apiAuth.put(`/referentes/${id}`, payload);
  return res.data;
}

export async function eliminarReferente(id) {
  const res = await apiAuth.delete(`/referentes/${id}`);
  return res.data;
}

export async function subirFotoReferente(id, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiAuth.post(`/referentes/${id}/photo`, formData);
  return res.data;
}